// ControlCheckboxFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import ControlModel    from 'ControlModel.js';
import CheckboxControlView  from 'common-inputs/CheckboxControlView.js';


//=============================================================================
//
// Creates a checkbox, given a factoryService parameter key and
// a layout position. The factory key defines the
// control appearance through its template..
//
// -Maty Rocha, February 11, 2016
//
//=============================================================================
class ControlCheckboxFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos, isGroupChild = false ) {

        const attributes = this.createChildAttributes( factoryKey, pos, isGroupChild ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.value =  'Value';
        attributes.text = 'Check';
        attributes.checked = '';
        attributes.selected = false;
        attributes.styleColorText ='~selectionTextColor';
        attributes.styleColorTextOver ='~selectionTextOverColor';
        attributes.fontFamily = '~selectionFont';
        attributes.fontSize = '~selectionFont';
        attributes.textWeight = '~selectionFont';
        attributes.textStyle  = '~selectionFont';
        attributes.borderColor = '~selectionBorderColor';
        attributes.backgroundColor = '~selectionBgColor';
        attributes.transparentBackground = '~checkBgTransparent'; // PF-8700 added new property to allow transparent background, true by default
        attributes.advancedBgGradientColor = '~selectionBgGradientColor';
		attributes.inlineEditable = true;
		attributes.minWidth = 15;
		attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"}
        ];

        const view = new CheckboxControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id} );

        return view;
    }

}

const controlCheckboxFactory = new ControlCheckboxFactory();

export default controlCheckboxFactory;
